import React from 'react';

import { CustomCellRendererProps } from 'ag-grid-react';

import { useFeatureFlag } from '@/app/services/features';

import './DonorPartnershipCellRenderer.css';

const PARTNERSHIP_YES = 100000001;
export const DonorPartnershipCellRenderer = (
  params: CustomCellRendererProps,
): React.ReactElement => {
  try {
    const hasOwnership = params.data?.donor?.ownerships?.[0]?.endDate
      ? new Date(params.data?.donor?.ownerships?.[0]?.endDate) > new Date() &&
        params.data?.donor?.ownerships?.[0]?.percentage < 100
      : false;
    const hasPartnerships = params.data?.loadDonorPartners === PARTNERSHIP_YES;
    const isPartnershipUpdateEnabled = useFeatureFlag('Partnership_Update');
    const hasBadge = hasOwnership || hasPartnerships;
    const hasOwnershipOnly = hasOwnership && !hasPartnerships;
    const badgeTitle =
      isPartnershipUpdateEnabled && hasOwnershipOnly
        ? 'Has Ownership, no partnership created yet'
        : 'Bill Partnership';
    const badgeColorClass =
      isPartnershipUpdateEnabled && hasOwnershipOnly
        ? 'bg-blue-500'
        : 'bg-green-500';
    const isExport = params.data?.export !== 0;

    return (
      <span className="custom-cell__donor-partnership">
        {hasBadge && (
          <span
            className={`partnership-badge mr-2 inline-flex h-5 w-5 items-center justify-center rounded-full text-xs font-semibold text-white ${badgeColorClass}`}
            title={badgeTitle}
          >
            P
          </span>
        )}
        {isExport && (
          <span
            className="export-badge mr-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-yellow-500 text-xs font-semibold text-white"
            title="Export"
          >
            E
          </span>
        )}
        {params.value ?? ''}
      </span>
    );
  } catch (error) {
    console.error('Error in DonorPartnershipCellRenderer:', error);
    return (
      <span className="custom-cell__donor-partnership">
        {params.value ?? ''}
      </span>
    );
  }
};
